var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoIocn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_65906",
    "data-name": "Group 65906",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16419",
    "data-name": "Rectangle 16419",
    width: 25,
    height: 25,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "undo-right-round-svgrepo-com",
    d: "M8.431,3.516a.908.908,0,0,0-1.284,0L3.516,7.147a.908.908,0,0,0,0,1.284l3.631,3.631a.908.908,0,0,0,1.284-1.284L6.349,8.7H17.472a5.144,5.144,0,1,1,0,10.288H9A.908.908,0,1,0,9,20.8h8.473a6.96,6.96,0,1,0,0-13.919H6.349L8.431,4.8A.908.908,0,0,0,8.431,3.516Z",
    transform: "translate(-1.432 0.75)",
    fill: "#102633",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIocn);
export default __webpack_public_path__ + "static/media/undoIocn.671dd50c55bba6e92c4543fdd09abd5c.svg";
export { ForwardRef as ReactComponent };